<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="处理类型">
					<el-radio-group v-model="methond">
						<el-radio :label="1">快递</el-radio>
						<el-radio :label="2">内部</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="快递处理" v-if="methond == 1">
					<el-select v-model="form.actiontype" placeholder="请选择">
						<el-option v-for="item in deliveryoptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<div v-if="methond == 2">
					<el-form-item label="内部处理" v-if="methond == 2">
						<el-select v-model="form.internalactiontype" placeholder="请选择">
							<el-option v-for="item in internaloptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="其他处理" >
						<el-input v-model="form.actionmark" placeholder="请输入内容"></el-input>
					</el-form-item>
				</div>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return {}
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				deliveryoptions: [{
						value: 0,
						label: "未处理"
					},
					{
						value: 1,
						label: "提前揽收"
					},
					{
						value: 2,
						label: "催件"
					},
					{
						value: 3,
						label: "更换快递单号"
					}
				],
				internaloptions: [{
						value: 0,
						label: "未处理"
					},
					{
						value: 4,
						label: "催发货"
					},
					{
						value: 5,
						label: "重新打单"
					},
					{
						value: 6,
						label: "关闭订单"
					}
				],
				methond:1,
				form: {
					actiontype: null,
					actionmark:null,
					internalactiontype: null,
				},
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {

			},
			cancel() {
				this.form.actiontype = null
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			submit() {
				console.log(this.row, this.form)
				let data = []
				let salercpt_no = []
				this.row.forEach((item) => {
					salercpt_no.push(item.salercpt_no)
					if (item.express_uid) {
						data.push(item.express_uid)
					}
				})
				if(this.methond == 1){
					if (this.form.actiontype == 1 || this.form.actiontype == 2) {
						this.$emit('deliverytool', {
							data: data,
							action: this.form.actiontype
						})
						this.cancel()
					} else {
						this.handle(salercpt_no)
					}
				}else{
					this.handle(salercpt_no)
				}
			},
			handle(salercpt_no){
				let actiontype = this.form.actiontype
				if(this.methond == 2){
					actiontype = this.form.internalactiontype
				}
				this.$api.compensationnotice.handle({
					salercpt_no: salercpt_no,
					actiontype: actiontype,
					actionmark:this.form.actionmark
				}).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})
			}
		},
		components: {

		}
	}
</script>